import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button"];

  connect() {}
  submit() {
    this.buttonTarget.disabled = true;
    this.buttonTarget.value = this.buttonTarget.dataset.disableWith;
  }
  reset() {
    this.buttonTarget.disabled = false;
    this.buttonTarget.value = this.buttonTarget.dataset.original;
  }
}
